import Phaser from "phaser";
import { signDataUrl } from "../ui/signage";

/**
 * Señal de seguridad PRL colocada en el mundo isométrico: un poste con un
 * panel que muestra la MISMA señal real (SVG de `signage.ts`) como textura.
 * Así el jugador aprende a reconocer la señalización observando el escenario,
 * sin necesidad de inspeccionar. La textura se genera una vez por id y se
 * reutiliza entre escenas (clave `sign_<id>`).
 */
export function worldSign(
  scene: Phaser.Scene,
  id: string,
  opts: { postHeight?: number; size?: number; wall?: boolean } = {},
): Phaser.GameObjects.Container {
  const c = scene.add.container(0, 0);
  const h = opts.wall ? 0 : opts.postHeight ?? 26;
  const size = opts.size ?? 30;

  const g = scene.add.graphics();
  if (!opts.wall) {
    g.fillStyle(0x000000, 0.18); g.fillEllipse(0, 3, 16, 6); // sombra
    g.fillStyle(0x8a8f96, 1); g.fillRect(-1.5, -h, 3, h);    // poste
    g.fillStyle(0x6f747b, 1); g.fillRect(0.4, -h, 1, h);     // brillo del poste
  }
  c.add(g);

  const key = "sign_" + id;
  const place = (): void => {
    if (!c.scene) return; // el contenedor pudo destruirse al cambiar de escena
    const im = scene.add.image(0, -h - size / 2 + 3, key).setDisplaySize(size, size);
    c.add(im);
  };

  if (scene.textures.exists(key)) {
    place();
  } else {
    const url = signDataUrl(id, 128);
    if (!url) return c;
    const img = new Image();
    img.onload = (): void => {
      if (!scene.textures.exists(key)) scene.textures.addImage(key, img);
      place();
    };
    img.src = url;
  }
  return c;
}
